var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFolder = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.625 7.20043H36.3C45.525 7.20043 50.025 12.1254 50 22.2254V34.4004C50 44.0504 44.05 50.0004 34.375 50.0004H15.6C5.975 50.0004 0 44.0504 0 34.3754V15.6004C0 5.25043 4.6 0.000426651 13.675 0.000426651H17.625C19.9525 -0.0245733 22.125 1.05043 23.55 2.87543L25.75 5.80043C26.45 6.67543 27.5 7.20043 28.625 7.20043ZM13.425 33.2254H36.575C37.6 33.2254 38.425 32.3754 38.425 31.3504C38.425 30.3004 37.6 29.4754 36.575 29.4754H13.425C12.375 29.4754 11.55 30.3004 11.55 31.3504C11.55 32.3754 12.375 33.2254 13.425 33.2254Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFolder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Folder.6b1618ba.svg";
export { ForwardRef as ReactComponent };